// Copyright 2025. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { Wrapper } from 'common/components/TopBar/Styles';
import { Button } from '@plesk/ui-library';
import { INTENT_TYPE } from 'common/constants';
import { Link } from 'react-router-dom';

export interface ITopBarProps extends React.HTMLProps<HTMLElement> {
    linkText?: React.ReactNode;
    onLinkClick?: () => void;
    linkTo?: string;
    intent?: INTENT_TYPE;
    color?: string;
    backgroundColor?: string;
    dataCy?: string;
}

export const TopBar: React.FC<ITopBarProps> = ({
    children,
    onLinkClick,
    linkTo,
    linkText,
    color,
    backgroundColor,
    dataCy,
}) => (
    <Wrapper color={color} backgroundColor={backgroundColor} data-cy={dataCy}>
        {children}

        {linkText && (
            linkTo
                ? (<Button ghost={true} intent="primary" component={Link} to={linkTo}>
                    {linkText}
                </Button>)
                : (<Button ghost={true} intent="primary" onClick={onLinkClick}>
                    {linkText}
                </Button>)
        )}
    </Wrapper>
);

export default TopBar;
